















































import { Auth } from "aws-amplify";
import { Component, Mixins } from "vue-property-decorator";

import HasAlerts from "@/mixins/HasAlerts.vue";
import AlertList from "@/components/AlertList.vue";

interface ForgotPasswordResponse {
  CodeDeliveryDetails: {
    AttributeName: string;
    DeliveryMedium: string;
    Destination: string;
  };
}

@Component({
  components: { AlertList }
})
export default class ForgotPassword extends Mixins(HasAlerts) {
  private email: string = "";

  private status: "Loading" | "Idle" = "Idle";

  async request() {
    try {
      this.status = "Loading";

      const response: ForgotPasswordResponse = await Auth.forgotPassword(
        this.email
      );

      this.flash(
        {
          type: "success",
          message: `An ${
            response.CodeDeliveryDetails.DeliveryMedium
          } with the verification code was sent to ${
            response.CodeDeliveryDetails.Destination
          }.`
        },
        { global: true }
      );

      this.$router.push({
        name: "forgot-password-submit",
        query: { email: this.email }
      });
    } catch (ex) {
      this.flash(
        {
          type: "danger",
          message: ex.message || ex
        },
        { global: false }
      );
    } finally {
      this.status = "Idle";
    }
  }
}
